// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"238":"9ad77063","652":"9ad77063","770":"9ad77063"}[chunkId] + ".chunk.css";
};